import React, {useState, useContext, useEffect, useRef, useMemo} from 'react';
import axios from 'axios';
import moment from 'moment';
import classNames from 'classnames';
import Qs from 'qs';
import {useTranslation} from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';

import CartoucheSeance from 'components/CartoucheSeance';
import LanguageSelector from 'components/LanguageSelector';
import Context from 'utils/Context';
import Conf from 'utils/Conf';
import defaultCinemaBackground from 'assets/cinema-background.jpg';

import './Multiplex.scss';
import Screen from './Screen';
import ChatPane from './ChatPane';
import Countdown from './NewCountdown';

const Multiplex = ({params, data}) => {
  const [needInteraction, setNeedInteraction] = useState(true);
  const chatState = useRef(null);

  const tzStartTime = useMemo(() => moment.tz(data.event.start_time, data.cinema.zone_name), [
    data.event.start_time,
    data.cinema.zone_name,
  ]);

  const [countdown, setCountdown] = useState(tzStartTime.diff());
  const {appState, modele} = useContext(Context);
  const {t} = useTranslation();

  const salleRef = useRef(null);

  const lightsOn = countdown > 15000;
  const showChat = true;

  useEffect(() => {
    if (countdown < 0) return;
    const timeout = setTimeout(() => {
      setCountdown(tzStartTime.diff());
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [tzStartTime, countdown]);

  useEffect(() => {
    const presenceTick = () => {
      axios
        .post(
          `${Conf.apiBaseUriLegacy}/event_presence_tick/${params.id}`,
          Qs.stringify({
            hash: params.hash,
            uuid: appState.uuid,
            last_timestamp: 0,
            chat_state: chatState.current,
          }),
          {
            withCredentials: true,
          },
        )
        .then(res => {
          chatState.current = res.data.chat_state;
        });
    };

    const interval = setInterval(presenceTick, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [appState.uuid, params.hash, params.id]);

  const toggleFullScreen = e => {
    e.stopPropagation();
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.body.requestFullscreen();
    }
  };

  let backgroundStyle = {
    backgroundImage: `url('${defaultCinemaBackground}')`,
  };

  if (data.cinema.background) {
    // const basename = data.cinema.background.split(/[\\/]/).pop();
    // const background = data.cinema.background.replace(basename, `min/${basename}`);

    backgroundStyle.backgroundImage = `url("${Conf.assetsRoot}${data.cinema.background}")`;
  }

  return (
    <div className="multiplex-container" ref={salleRef} onDoubleClick={toggleFullScreen}>
      {!needInteraction && <Screen evenement={data.event} countdown={countdown} salleRef={salleRef} />}
      <div className={classNames('multiplex-container-inner', {lightsOn})} style={backgroundStyle}>
        {showChat && <ChatPane event={data.event} />}
        <div className="multiplex-waiting">
          <div className="multiplex-cartouche">
            <CartoucheSeance
              hideBtns
              seance={{
                zone_name: data.cinema.zone_name,
                intervenants: data.intervenants,
                film_name: data.film.name,
                city_name: data.cinema.city_name,
                cinema_name: data.cinema.name,
                event_id: data.event.id,
                tzStartTime,
                affiche: data.film.affiche,
              }}
              appState={appState}
              modele={modele}
            />
          </div>
          <Countdown remainingMs={countdown} />
        </div>
        <div className={'screen-lang-selector show'}>
          <LanguageSelector appState={appState} container={salleRef.current} />
        </div>
      </div>
      <Dialog open={needInteraction} onClose={() => setNeedInteraction(false)} className="my-dialog">
        <DialogContent>
          <DialogContentText>{t('bienvenue-dans-votre-salle-de-cinema-virtuelle')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setNeedInteraction(false)}>
            {t('entrer')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Multiplex;
